module.exports = __webpack_public_path__ + "static/media/icon-back.e1cdb3c1.svg";